import ContactsActionMenu from './ContactsActionMenu.component';

export default ContactsActionMenu;
